import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-formulario-convenio',
  templateUrl: './formulario-convenio.component.html',
  styleUrls: ['./formulario-convenio.component.scss']
})
export class FormularioConvenioComponent implements OnInit {
    
    public errors: any = {};
    public contratos: any [] = [];
    public rentas: any [] = [];

    constructor() {
    }

    ngOnInit() {
    }
}


// WEBPACK FOOTER //
// ./src/app/components/convenios/formulario-convenio/formulario-convenio.component.ts